import React, { useEffect, useRef, useState } from 'react';

import { MOUSE_DOWN_EVENT, VIDEO_INPUT } from 'utils/constants';

import styles from './style.module.scss';

const CameraSwitch = ({ selectedCameraId, setSelectedCameraId }) => {
  const [open, setOpen] = useState(false);
  const [availableCameras, setAvailableCameras] = useState([]);
  const containerRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);
  const handleCameraSelect = (id) => {
    setSelectedCameraId(id);
    setOpen(false);
  };

  useEffect(() => {
    const loadCameras = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        const devices = await navigator.mediaDevices.enumerateDevices();
        const cameras = devices.filter((d) => d.kind === VIDEO_INPUT);
        stream.getTracks().forEach((track) => track.stop());
        setAvailableCameras(cameras);
        setSelectedCameraId(cameras[0]?.deviceId || null);
      } catch (err) {
        console.error('Could not load cameras', err);
      }
    };
    loadCameras();
  }, [setSelectedCameraId]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
    return () =>
      document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
  }, []);

  const selectedCamera = availableCameras.find(
    (cam) => cam.deviceId === selectedCameraId
  );

  return (
    <div className={styles.container}>
      <div className={styles.dropdown} ref={containerRef}>
        <div className={styles.dropdownButton} onClick={toggleDropdown}>
          <span>{selectedCamera?.label || 'Select Camera'}</span>
          <div className={styles.arrow} />
        </div>
        {open && (
          <div className={styles.options}>
            {availableCameras.map((cam) => (
              <div
                key={cam.deviceId}
                className={styles.option}
                onClick={() => handleCameraSelect(cam.deviceId)}
              >
                {cam.label || `Camera ${cam.deviceId}`}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CameraSwitch;
